import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import avt from "../../assets/images/Default_user_image.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";
import logo2 from "../../assets/images/logo2.png";
import { SearchOutlined } from "@mui/icons-material";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import LogoutSharpIcon from "@mui/icons-material/LogoutSharp";
import WorkHistorySharpIcon from "@mui/icons-material/WorkHistorySharp";
import AssignmentSharpIcon from "@mui/icons-material/AssignmentSharp";
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp";
import GobalSearch from "../../khojpages/GlobalSearch/GobalSearch";
import TopNotification from "./TopNotification";

// CRHeader.propTypes = {};


function CRHeader({ clname = "", handleMobile }) {
	const [isDark, setIsDark] = useLocalStorage("isDark", false);
	const userType = localStorage.getItem("userType");
	console.log("userType", userType);

	// const profileImage = localStorage.getItem("profilPic");
	const [profileImage, setProfileImage] = useState(localStorage.getItem("ProfileImage") || "default-profile.png"); // Default image
	const module = localStorage.getItem('Module')
	const [key, setKey] = useState(0); // Force re-render

	useEffect(() => {
		const handleStorageChange = () => {
			console.log("🔄 Profile image updated:", localStorage.getItem("ProfileImage"));
			setProfileImage(localStorage.getItem("ProfileImage") || "default-profile.png");
			setKey(prevKey => prevKey + 1);
		};
		window.addEventListener("profileImageUpdated", handleStorageChange);
		return () => {
			window.removeEventListener("profileImageUpdated", handleStorageChange);
		};
	}, []);


	const [scroll, setScroll] = useState(0);

	useEffect(() => {
		document.addEventListener("scroll", () => {
			const scrollCheck = window.scrollY > 100;
			if (scrollCheck !== scroll) {
				setScroll(scrollCheck);
			}
		});
	}, []);

	const navigate = useNavigate();
	const location = useLocation();

	const handleNavigation = (path) => {
		if (location.pathname === path) {
			window.location.reload(); // Force a full page reload
		} else {
			navigate(path);
		}
	};
	// ..................................................................................
	// ..................................................................................


	// Example data for each tab
	const [activeTab, setActiveTab] = useState("notification"); // Active tab tracking
	const notifications = [
		{ time: "Last day", content: "Your submit job Graphic Design is Success" },
		{
			time: "5 Days ago",
			content:
				"A new application is submitted on your job Graphic Design by Maverick Nguyen",
		},
	];

	const alertjobs = [
		{
			time: "Last day",
			content: "Your Graphic Design job has been posted successfully",
		},
		{
			time: "3 Days ago",
			content: "Another applicant applied for Graphic Design",
		},
	];

	const Interviews = [
		{
			time: "Yesterday",
			content: "Your interview for Graphic Design is scheduled for tomorrow",
		},
	];



	// Function to render content based on the selected tab
	const renderContent = (items, setState) =>
		items.map((item, index) => (
			<div key={index} className=" ">
				<div className="mt-1">
					<div className="sub-notification-content">
						<div className="sub-notification-item icon-plus">
							<div className="time Notification-Text">{item.time}</div>
							<div className="content Notification-Text">
								{item.content}
								{/* <span className="name">Graphic Design</span> is&nbsp;
                          <span className="status">Success</span> */}
							</div>
						</div>
					</div>
				</div>
			</div>
		));

	const [userData, setUserData] = useState({
		entityName: "",
		email: "",
		userType: "",
		profilePic: "",
		userUID: "",
	});

	useEffect(() => {
		const entityName = localStorage.getItem("entityName");
		// const lastName = localStorage.getItem("lastName") ;
		const email = localStorage.getItem("email");
		const userType = localStorage.getItem("userType");
		const userUID = localStorage.getItem("userUID");
		const profilePic = localStorage.getItem("profilePic");

		setUserData({ entityName, email, userType, profilePic, userUID });
	}, []);

	// ........................................................................
	// ........................................................................
	return (
		<>
			<header
				id="header"
				className={`header khojdesktopHeader pt-3 header-default loginkhojHeader `}
			>
				<div className="px-4 ct2">
					<div className="row">
						<div className="col-md-12">
							<div className="sticky-area-wrap">
								<div className="header-ct-left">
									{isDark ? (
										<div id="logo" className="logo">
											<Link to="/Home" onClick={() => handleNavigation("/Home")}>
												<img
													className="site-logo"
													id="trans-logo"
													src={logo2}
													alt="logo"
												/>
											</Link>
										</div>
									) : (
										<div id="logo" className="logo">
											<Link to="/Home" onClick={() => handleNavigation("/Home")}>
												<img
													className="site-logo"
													id="trans-logo"
													src={logo}
													alt="logo"
												/>
											</Link>
										</div>
									)}
								</div>
								<div className="form-group-1 khojSearch d-flex align-items-center">
									<GobalSearch />

								</div>
								<div className="header-ct-center">
									<div className="nav-wrap">

										<nav id="main-nav" className="main-nav">
											<ul id="menu-primary-menu" className={`menu mb-2 ${clname} mt-1`}>
												<li className="menu-item sub3">
													<Link to="/Candidate/All"  >
														<AccountCircleSharpIcon />
													</Link>
													<NavLink to="/Candidate/All"  >Candidates</NavLink>
												</li>

												<li className="menu-item menu-item-has-children sub4">
													<Link>
														<WorkHistorySharpIcon />
													</Link>
													<Link to="#">Manage Job</Link>

													<ul className="dropdown-menu sub-menu st1">
														<Link to="/job/Add"  >
															<li className="dropdown-item">
																<Link to="/job/Add" >Post Jobs</Link>
															</li>
														</Link>
														<Link to="/job/My-Jobs"  >
															<li className="dropdown-item">
																<NavLink to="/job/My-Jobs"> Jobs List</NavLink>
															</li>
														</Link>
													</ul>
												</li>

												<li className="menu-item menu-item-has-children sub4">
													<Link>
														<AssignmentSharpIcon />
													</Link>
													<Link to="#">Applications</Link>

													<ul className="dropdown-menu sub-menu st1">
														<Link to="/Applications"  >
															<li className="dropdown-item">
																<Link to="/Applications" >Manage Applications</Link>
															</li>
														</Link>
														<Link to="/Interviews" >
															<li className="dropdown-item">
																<NavLink to="/Interviews">Interviews</NavLink>
															</li>
														</Link>
														{
															userType === "Company" || userType === "Recruiter" ?
																<Link to="/AssignedTests" >
																	<li className="dropdown-item assigned-test">
																		<NavLink to="/AssignedTests">Assigned Tests</NavLink>
																	</li>
																</Link>
																: ""
														}

													</ul>
												</li>
											</ul>
										</nav>

									</div>
								</div>
								<div className="header-ct-right">
									<Toggle
										isChecked={isDark}
										handleChange={() => setIsDark(!isDark)}
									/>

									<TopNotification />



									<div className="nav-wrap">
										<nav id="main-nav" className="main-nav">
											<ul
												id="menu-primary-menu"
												className={`menu profileMenu mb-2 p-0 ${clname}`}
											>
												<li className="menu-item menu-item-has-children profile-img m-0">
													{/* <Link to="#"> */}
													{/* <img src={profileImage} width={40} alt="User Logo" className="userProfileHeader" /> */}
													<img
														src={profileImage}
														width={40}
														// key={key}
														// alt="User Logo"
														className="userProfileHeader"
													/>
													{/* </Link> */}

													<div className="header-customize-item bell pro  ">
														<div className="sub-notification profile">
															<div className="tabs row">
																<li>
																	<div className=" d-flex HeaderFLName">
																		<h6> {`${userData.entityName}`}</h6>
																	</div>
																	<div className="HeaderEmail">
																		<h6> {userData.email}</h6>
																	</div>
																	<div className="HeaderUserType">
																		<h6> {userData.userType}</h6>
																	</div>
																</li>

																<li className="nav-sub">
																	<AccountCircleSharpIcon />
																	<Link to={`/${userData.userType}/${userData.userUID}`}  >
																		Profile</Link>
																</li>
																<li className="nav-sub">
																	<SettingsSharpIcon />
																	<NavLink to="/Settings"  >Settings</NavLink>
																</li>
																<li className="nav-sub">
																	<LogoutSharpIcon />
																	<NavLink
																		to="/Login"
																		onClick={() => {
																			const isDarkValue = localStorage.getItem('isDark'); // Store the value of isDark
																			localStorage.clear(); // Clear all localStorage
																			if (isDarkValue !== null) {
																				localStorage.setItem('isDark', isDarkValue); // Restore the isDark key if it exists
																			}
																		}}
																	>
																		Logout
																	</NavLink>
																</li>
															</div>
														</div>
													</div>
												</li>
											</ul>
										</nav>
									</div>
								</div>
								<div className="nav-filter" onClick={handleMobile}>
									<div className="nav-mobile">
										<span></span>
									</div>
								</div>

								{/* <div className="" style={{ margin: '5px' }}>
                <Link to="/forgetpassword">
                  <button>Forget</button>
                </Link>

              </div> */}
							</div>
						</div>
					</div>
				</div>
			</header>
			<header
				id="header"
				className={`header khojmobileHeader pt-3 header-default loginkhojHeader `}
			>
				<div className="px-4 ct2">
					<div className="row">
						<div className="col-md-12">
							<div className="sticky-area-wrap">
								<div className="header-ct-left">
									<div className="nav-wrap">
										<nav id="main-nav" className="main-nav profileNav ">
											<ul
												id="menu-primary-menu"
												className={`menu profileMenu mb-2 ${clname} Nav-Header-Mobile mt-1`}
											>
												<div className="nav-filter" onClick={handleMobile}>
													<div className="nav-mobile">
														<span></span>
													</div>
												</div>

												{/* <li className="menu-item menu-item-has-children">
													<Link to="#">
														<img
															src={profileImage}
															width={40}
															alt="User Logo"
															className="userProfileHeader"
														/>
													</Link>
													<ul className="sub-menu st1">
														<li>
															<div className=" d-flex HeaderFLName">
																<h6> {`${userData.entityName}`}</h6>
															</div>
															<div className="HeaderEmail">
																<h6> {userData.email}</h6>
															</div>
															<div className="HeaderUserType">
																<h6> {userData.userType}</h6>
															</div>
														</li>

														<li className="nav-sub">
															<AccountCircleSharpIcon />
															<Link to="/Profile">Profile</Link>
														</li>
														<li className="nav-sub">
                                                            <DeleteForeverSharpIcon />
                                                            <NavLink to="/changepassword">
                                                                Change Password
                                                            </NavLink>
                                                        </li>
														<li className="nav-sub">
															<SettingsSharpIcon />
															<NavLink to="/Settings">Settings</NavLink>
														</li>
														<li className="nav-sub">
															<LogoutSharpIcon />
															<NavLink
																to="/Login"
																onClick={() => {
																	const isDarkValue = localStorage.getItem('isDark'); // Store the value of isDark
																	localStorage.clear(); // Clear all localStorage
																	if (isDarkValue !== null) {
																		localStorage.setItem('isDark', isDarkValue); // Restore the isDark key if it exists
																	}
																}}
															>
																Logout
															</NavLink>
														</li>
													</ul>
												</li> */}
											</ul>
										</nav>
									</div>
									{/* {isDark ? (
										<div id="logo" className="logo">
											<Link to="/">
												<img
													className="site-logo"
													id="trans-logo"
													src={logo2}
													alt="logo"
												/>
											</Link>
										</div>
									) : (
										<div id="logo" className="logo">
											<Link to="/">
												<img
													className="site-logo"
													id="trans-logo"
													src={logo}
													alt="logo"
												/>
											</Link>
										</div>
									)} */}
								</div>
								<div className="form-group-1 khojSearch d-flex align-items-center">
									<GobalSearch />
								</div>
								<div className="header-ct-right">
									<TopNotification />
									<div className="ms-auto me-2 mobileToggle">
										<Toggle
											isChecked={isDark}
											handleChange={() => setIsDark(!isDark)}
										/>
									</div>
									{/* <div className="nav-filter" onClick={handleMobile}>
										<div className="nav-mobile">
											<span></span>
										</div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
}

export default CRHeader;
